<template>

    <div id="content-list-module"
         class="flex flex-row flex-none flex-1 w-full py-6 bg-theme-level4 border-b border-theme-level3 hover-trigger"
         style="min-height: 160px;">

        <div class="w-4 text-sm text-theme-discrete ml-6" style="min-width: 25px;">
            <!--suppress HtmlFormInputWithoutLabel -->
            <input type="checkbox" class="form-checkbox h-4 w-4 text-theme-controls3 hidden">
        </div>

        <div class="flex text-sm text-theme-discrete ml-4" style="width: 120px;">
            <div v-if="!thumbnail" class="flex flex-col items-center justify-center bg-theme-level3 rounded-lg shadow" style="width: 120px; height: 68px;">
                <i class="material-icons w-6 h-6 text-theme-xmuted">visibility_off</i>
            </div>
            <img v-else :src="thumbnail" alt="" style="width: 120px; height: 68px;" class="shadow-md">
        </div>

        <div class="flex flex-col w-4/12 text-sm text-theme-discrete ml-6">

            <!--<a :href="viewLink" class="mb-2"><span class="text-sm font-bold text-theme-title leading-tight" v-text="title"
                @click.prevent="doIt"></span></a>-->

            <div class="mb-2 cursor-pointer text-theme-main hover:text-theme-title"><span class="text-sm font-bold leading-tight" v-text="title"
                                                   @click="showPlayerInAdmin"></span></div>

            <div class="h-8 overflow-hidden">
                <span class="text-xs text-theme-discrete mt-3 mb-2 leading-normal" v-text="abstract"></span>
            </div>



            <div id="content-text-panel" class="h-20 hover-target">
                <div class="mt-2">
                    <span class="text-xs font-bold">{{ translate('content-list-category') }}: </span>
                    <span v-for="(category, key) in categories" class="text-xs"><span v-if="key !== 0">, </span>{{ category }}</span>
                </div>
                <div class="mt-2">
                    <span class="text-xs font-bold">{{ translate('content-list-tags') }}: </span>
                    <span v-for="(tag, key) in tags" class="text-xs"><span v-if="key !== 0">, </span>{{ tag }}</span>
                </div>
                <div class="mt-2">
                    <span class="text-xs font-bold">{{ translate('content-list-persons') }}: </span>
                    <span v-if="pois.length===0" class="text-xs">{{ translate('content-list-unassigned') }}</span>
                    <span v-for="(poi, key) in pois" class="text-xs"><span v-if="key !== 0">, </span><span v-if="poi.id !== assignedCorrespondent">{{ poi.name }}</span></span>
                </div>
                <div class="mt-2">
                    <span class="text-xs font-bold">{{ translate('content-list-correspondents') }}: </span>
                    <span class="text-xs" v-text="correspondentName"></span>
                </div>
            </div>



            <div id="content-controls-icons-panel"
                 class="h-20 hover-target-secondary">

                <div class="flex flex-row items-center justify-center h-full w-full">

                    <span class="relative w-8 h-8 hover:bg-theme-level2 cursor-pointer rounded-lg hover-vis-trigger text-theme-muted hover:text-theme-main" @click="editContent">
                        <i class="material-icons w-6 h-6 pl-1 pt-1">edit</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('edit') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                    <span class="relative w-8 h-8 ml-4 hover-vis-trigger">
                        <i class="material-icons w-6 h-6 pl-1 pt-1 text-theme-xmuted">aspect_ratio</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target flex-1 w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('module') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                    <span class="relative w-8 h-8 ml-4 hover-vis-trigger">
                        <i class="material-icons w-6 h-6 pl-1 pt-1 text-theme-xmuted">timeline</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target flex-1 w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('stats') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                    <span class="relative w-8 h-8 ml-4 hover-vis-trigger">
                        <i class="material-icons w-6 h-6 pl-1 pt-1 text-theme-xmuted">comments</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target flex-1 w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('moderate') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                    <span class="relative w-8 h-8 ml-4 hover-vis-trigger">
                        <i class="material-icons w-6 h-6 pl-1 pt-1 text-theme-xmuted">visibility_off</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target flex-1 w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('deactivate') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                    <span class="relative w-8 h-8 ml-4 hover-vis-trigger">
                        <i class="material-icons w-6 h-6 pl-1 pt-1 text-theme-xmuted">save_alt</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target flex-1 w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('download') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                    <!--<span class="relative w-8 h-8 ml-12 hover-vis-trigger">-->
                    <span class="relative ml-12 w-8 h-8 hover:bg-theme-level2 cursor-pointer rounded-lg hover-vis-trigger text-red-200 hover:text-red-500" @click="deleteContent">
                        <i class="material-icons w-6 h-6 pl-1 pt-1">delete_forever</i>
                        <span class="absolute px-3 py-1 mb-1 bg-theme-copy3 rounded-lg text-xs text-white text-center
                                hover-vis-target flex-1 w-18
                                transform transition-all duration-200"
                              style="bottom: 100%; left: 50%; transform: translate(-50%, 0);">
                            {{ translate('content-delete') }}
                            <svg class="absolute text-theme-copy3 w-full h-2"
                                 style="top: 100%; left: 0;"
                                 x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-current" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </span>
                    </span>

                </div>
            </div>

        </div>

        <div class="flex flex-col w-1/12 text-sm text-theme-discrete ml-6 items-start">
            <span class="text-sm mb-1 text-theme-muted mb-1">{{ translate('content-list-publish') }}:</span>
            <!--<span class="mb-1" :class="{ 'publishing-pending': date >= currentDate }" v-text="date"></span>-->
            <span class="mb-1" :class="{ 'text-orange-500': shouldBePublished }" v-text="date"></span>
            <span class="text-sm mt-1 mb-1 text-theme-muted">{{ translate('at') }}:</span>
            <span class="mb-1" :class="{ 'text-orange-500': shouldBePublished }" v-text="time"></span>
            <span class="text-sm mt-1 mb-1 text-theme-muted">{{ translate('status') }}:</span>
            <span v-if="shouldBePublished" class="mb-1" :class="{ 'text-orange-500': shouldBePublished }">{{ translate('unpublished') }}</span>
            <span v-else class="mb-1">{{ translate('published') }}</span>
        </div>

        <div class="flex flex-col w-1/12 text-sm text-theme-discrete ml-6">
            <span v-text="visibility"></span>
            <span class="mt-4 text-xs font-bold text-theme-discrete">{{ translate('content-list-module-size') }}:</span>
            <span class="mt-1" v-text="renderSize"></span>
        </div>

        <div class="flex w-1/12 text-sm text-theme-discrete ml-6">
            <span v-text="restrictions"></span>
        </div>


        <div class="flex w-1/12 text-sm text-theme-discrete ml-6">
            <div>
                    <span class="flex flex-row items-center mb-2">
                        <i class="material-icons w-6 h-6 mr-3 text-theme-xmuted">play_circle_outline</i><span v-text="plays"></span>
                    </span>

                <span class="flex flex-row items-center">
                        <i class="material-icons w-6 h-6 mr-3 text-theme-xmuted">thumbs_up_down</i>
                        <span class="text-green-500" v-text="likes"></span>
                        <span class="ml-1 mr-1">/</span>
                        <span class="text-red-500" v-text="dislikes"></span>
                    </span>
            </div>
        </div>


    </div>

</template>

<script>

    import moment from 'moment';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {

            return {
                viewLink: '/view/' + this.content.id,
                contentId: this.content.id,
                filename: this.content.filename,
                title: this.content.title,
                abstract: this.content.abstract,
                thumbnail: '',
                assignedCorrespondent: this.content.correspondent_id,

                date: moment(this.content.publish_date).format('YYYY-MM-DD HH:mm').split(' ')[0],
                time: moment(this.content.publish_date).format('YYYY-MM-DD HH:mm').split(' ')[1],
                renderSize: this.content.render_size,
                visibility: this.content.visibility,
                restrictions: this.content.restrictions,
                /*plays: '',
                likes: '',
                dislikes: '',*/
                comments: '---',

                currentDate: moment().format('YYYY-MM-DD'),
                currentTime: moment().format('HH:mm')
            }
        },

        computed: {

/*
            thumbnail() {

                if(this.content.thumbnail_url ==='') {
                    console.log('No thumbnail available')
                    return ''
                } else {
                    console.log('Thumbnail has value: ' + this.content.thumbnail_url);
                    return process.env.MIX_CLOUDFRONT_DNSNAME + this.content.thumbnail_url
                }

            },
*/

            publishedDate() {
                return this.date.toLocaleDateString();
            },

            shouldBePublished() {
                return ! (moment(this.currentDate + ' ' + this.currentTime) >= moment(this.date + ' ' + this.time) )
            },

            correspondentName() {
                let compareId = this.content.correspondent_id;

                let thePoi = this.pois.find(poi =>
                    poi.id === compareId
                );

                if(thePoi) {
                    return thePoi.name;
                } else {
                    return this.translate('content-list-unassigned');
                }
            }
        },

        props: [

            'content',
            'categories',
            'tags',
            'pois',
            'plays',
            'likes',
            'dislikes',
            'lastitem',
            'returnpage',
            'currentlocale'
        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            editContent() {
                console.log('You asked to edit Content with File Name ID: ' + this.contentId + ' titled: ' + this.title );
                window.location='/' + this.currentlocale + '/admin/content/legacy/edit/' + this.contentId;
                /*Event.fire('editContentWasPressed', { 'contentId': this.contentId });*/
            },

            deleteContent() {

                let response = prompt('Desea realmente eliminar el contenido con el título:\n"' + this.title + '" ?\nPor favor, confirme la operación escribiendo la palabra "eliminar".');
                if(response === 'eliminar') {
                    console.log('Proceeding to delete content with ID: ' + this.contentId);
                    let jumpTo = '/' + this.currentlocale + '/admin/content/legacy/delete/' + this.contentId + (this.lastitem ? ':' + this.returnpage : '');
                    window.location=jumpTo;
                } else {
                    console.log('The response was: "' + response + '", so we won\'t be deleting anything right now.');
                }
            },

            showPlayerInAdmin() {

                Event.fire('showPlayerLegacy', { language: this.currentlocale, data: this.content });

            },

            mounted() {

            }
        },

        created() {
            console.log('Content List Module received incoming locale: ' + this.currentlocale);
        }
    }

</script>
